import { useEffect } from 'react';
import { useAccount } from 'wagmi';
import { postWalletConnect } from '../lib/analyticsApi';

const STORAGE_PREFIX = 'abc_wallet_connect_logged:';

function todayUtc(): string {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD (UTC)
}

/**
 * Renders nothing. Watches the connected wallet and reports it to the analytics
 * API at most once per wallet per UTC day (throttled via localStorage, mirroring
 * the WelcomeModal "seen" pattern). Powers the admin "users connected" metric,
 * including wallets that connect but never vote or create a market.
 */
export function WalletConnectTracker(): null {
  const { address, isConnected } = useAccount();

  useEffect(() => {
    if (!isConnected || !address) return;
    const wallet = address.toLowerCase();
    const key = `${STORAGE_PREFIX}${wallet}`;
    let alreadyLogged = false;
    try {
      alreadyLogged = localStorage.getItem(key) === todayUtc();
    } catch {
      // localStorage may be unavailable (private mode); fall through and POST.
    }
    if (alreadyLogged) return;
    void postWalletConnect(wallet);
    try {
      localStorage.setItem(key, todayUtc());
    } catch {
      // Ignore: worst case we POST again, which the server dedupes per day.
    }
  }, [address, isConnected]);

  return null;
}
